module.exports = __webpack_public_path__ + "fonts/Roboto-400-greek4.1cbfc63.woff2";